import { render, staticRenderFns } from "./failedUploadDocsModal.vue?vue&type=template&id=4b947dc8&scoped=true"
import script from "./failedUploadDocsModal.vue?vue&type=script&lang=js"
export * from "./failedUploadDocsModal.vue?vue&type=script&lang=js"
import style0 from "./failedUploadDocsModal.vue?vue&type=style&index=0&id=4b947dc8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b947dc8",
  null
  
)

export default component.exports